/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import { UserGuideState } from "~/features/userGuide/types";
import { RootState } from "~/state/types";

const getState = (state: RootState) => state.userGuide;

const createSelector =
  <TSelected = unknown>(selector: (state: UserGuideState) => TSelected): ((rootState: RootState) => TSelected) =>
  (rootState) =>
    selector(getState(rootState));

// Status
export const selectUGComplianceRequestStatus = createSelector((state) => state.meta.complianceStatus);

// Data
export const selectUGComplianceStatus = createSelector((state) => state.data.compliance);
export const selectUGPayoutInfoStatus = createSelector((state) => state.data.payout);

export const selectUGHasPaymethodStatus = createSelector((state) => state.data.hasPaymethod);
